const env = "prod"; // Set dev | qa | prod

module.exports = {
  env: env,
};
